
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/happycustomers/[customerId]",
      function () {
        return require("private-next-pages/happycustomers/[customerId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/happycustomers/[customerId]"])
      });
    }
  